import{h as n}from"./chunk-V2DQWH6R.js";import{a as o}from"./chunk-EIZTQXKB.js";import{m as r}from"./chunk-HBP5N4FR.js";r();var p=e=>{let t=e!=null?e:n(o.getState());return t.endsWith("/")?t.slice(0,-1):t};export{p as a};
//# sourceMappingURL=chunk-QEBL3PVN.js.map
